// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b0862b02","453":"3d533b0a","455":"8106b80c"}[chunkId] + ".chunk.js";
};